import moment from 'moment';
import React from 'react'
import { Col, Row } from 'react-bootstrap'
import ProductPriceComponent from '../ProductPriceComponent';
import { useTranslation } from '../../hooks/useTranslation';

function DailyInventoryConfirmationComponent({ product, qty, customer, orderNUm }) {
    const { t } = useTranslation();

    return (
        <Row>
            <Col lg={6}>
                <div className="comp rvs-dtl border-left">
                    <div className="pb-4"><h4>{t("OrderDetails")} {t("Number")} {orderNUm}</h4></div>
                    <div><h5>{product.productName}</h5></div>
                    <Col className="expdate">{t("VoucherDate")}
                        <span className="mx-2">{moment(product.orderActiveDateStart).format('DD/MM/YYYY')}</span>
                    </Col>
                    <div className='pb-3 d-flex justify-content-between align-items-center'>
                        <span>{t("Price")}</span>
                        <ProductPriceComponent
                            product={product}
                        />
                    </div>
                    <div className='pb-3 d-flex justify-content-between align-items-center'>
                        <span>{t("Quantity")}</span>
                        <span>{qty}</span>
                    </div>
                    <div className='pb-3 d-flex justify-content-between align-items-center'>
                        <span>{t("Total")}</span>
                        <ProductPriceComponent
                            product={product}
                            multiply={qty}
                        />
                    </div>
                </div>
            </Col>
            <Col lg={6}>
                <div className="customer-dtls">
                    {!!customer && <div className="personal-dtls">
                        <div className="bold"><h5>{t("UserDetails")}</h5></div>
                        <Row>
                            <Col>{t("FullName")}</Col>
                            <Col className="bold txt">{customer.customerFirstName + " " + customer.customerLastName}</Col>
                        </Row>
                        <Row>
                            <Col>{t("Email")}</Col>
                            <Col className="bold txt">{customer.customerEmail}</Col>
                        </Row>
                        <Row>
                            <Col>{t("Phone")}</Col>
                            <Col className="bold txt">{customer.customerPhone}</Col>
                        </Row>
                    </div>
                    }

                </div>
            </Col>
        </Row>)
}

export default DailyInventoryConfirmationComponent